module.exports = __webpack_public_path__ + "static/media/MarcusHelping.f11f60b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/forskar-fredag/MarcusHelping.jpg
// module id = 200
// module chunks = 0